module.exports = __webpack_public_path__ + "media/images/sp/page_common/banner/banner_costumes-c077638a9871cc86680be0dddf66c409.webp";